import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './ny-w4.component.html';
import moment from 'moment';
import { SignaturePadModal } from '../signature/signature-pad.component';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const NyW4Component = {
    templateUrl,
    controller: Nyw4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function Nyw4Controller(onboardingActionPolicy, onboardingDocumentService, $uibModal, $state, $scope, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onShowI9 = onShowI9;
    vm.onRequestReview = onRequestReview;
    vm.onSign = onSign;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.ssnBlur = ssnBlur;
    vm.onClose = onClose;
    vm.onEditClicked = onEditClicked;

    vm.disableEmpFields = true;
    vm.reqReview = false;
    vm.canApproveForm = (rt) => canApproveForm(vm.application, rt);
    /*vm.ISPreview = false;*/
    vm.isSigned = false;
    vm.isSaved = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.showSavedNotification = false;
    vm.savedData = false;
    vm.previewUrl;
    vm.state = {
        view: 'W4'
    };
    vm.maritalStatusMapping = [
        { id: 4, status: 'single' },
        { id: 5, status: 'married' },
        { id: 6, status: 'head-of-household' }];

    vm.$onInit = function () {
        console.log(vm.resolve);
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'DD/MM/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        console.log(vm.employeeBankInfo);
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;

            });

        if (vm.savedInputs != null && vm.savedInputs.EmployeeFirstNameMiddleInitial != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //user profile default
            vm.employeeFirstNameMiddleInitial = vm.employeeProfile.FirstName;
            vm.employeeLastName = vm.employeeProfile.LastName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.aptNumber = vm.profile.HomeAddress?.AptNum;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.EmployeeFirstNameMiddleInitial != null) {
            //prefill this.userInputs
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
        } else {
            //prefill user info
            vm.employeeFirstNameMiddleInitial = vm.employeeProfile.FirstName;
            vm.employeeLastName = vm.employeeProfile.LastName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.aptNumber = vm.profile.HomeAddress?.AptNum;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
            if (vm.employeeBankInfo?.MaritalStatusID) {
                vm.employeeStatus = vm.maritalStatusMapping.reduce(function (result, item, index) {
                    if (item.id === vm.employeeBankInfo.MaritalStatusID) {
                        result = item.status;
                    }
                    return result;
                }, null);
            }
            vm.additionalStateWithholding = Number(vm.employeeBankInfo.WithholdingFed ?? 0);
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView) {
            if (this.userInputs != null && this.userInputs.EmployerBusinessAddress != null) { //owner inputs
                vm.hireDate = moment(this.userInputs.ServiceDate, 'DD/MM/YYYY').toDate();
                vm.employerName = this.userInputs.Employername
                vm.employerFederalEIN = this.userInputs.EmployerfederalEIN;
            } else if (vm.ownerInfo) {
                vm.employerName = vm.ownerInfo.Owner;
                vm.employerFederalEIN = vm.ownerInfo.FEIN;
                vm.hireDate = moment(vm.resolve.employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').toDate();
            }
        }
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
        utilityService.hideLoading();

    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }

    //function resolveEditable() {
    //    const appStatus = vm.application.ApplicationStatus;
    //    const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

    //    if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
    //    if (appStatus === 'Pending') return true;

    //    return !vm.application.HasSW4Form              // ? HasSW4Form
    //        || formStatus === 'Pending'
    //        || formStatus === 'Submitted'
    //        || formStatus === 'ReviewRequired';
    //}

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            vm.employeeFirstNameMiddleInitial = vm.employeeProfile.FirstName;
            vm.employeeLastName = vm.employeeProfile.LastName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.aptNumber = vm.profile.HomeAddress?.AptNum;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }

    }
    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        //warning for pending changes
        if (vm.taxForm && vm.taxForm.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "onboarding-document.federalW4";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    function fillEmployee(application) {
        console.log(application);
        vm.employeeSsn = application.EmployeeSocialSecurityNumber
        vm.employeeFirstNameMiddleInitial = application.EmployeeFirstNameMiddleInitial;
        vm.employeeLastName = application.EmployeeLastName;
        vm.address = application.EmployeeStreetaddress1Streetaddress2;
        vm.aptNumber = application.ApartmentNumber;
        vm.city = application.EmployeeCity;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === application.EmployeeState);
        vm.zipCode = application.EmployeeZip;
        vm.employeeStatus = application.FilingStatus;
        vm.residentNYC = application.ResidentNYC === 'true';
        vm.residentYonkers = application.ResidentYonkers === 'true';
        vm.totalAllowances = application.TotalAllowances;
        vm.totalAllowancesNYC = application.TotalAllowancesNYC;
        vm.additionalStateWithholding = application.AdditionalStateWithholding;
        vm.additionalNYCWithholding = application.AdditionalNYCWithholding;
        vm.additionalYonkersWithholding = application.AdditionalYonkersWithholding;
        if (application.Signature) {
            vm.signimage = application.Signature;
            vm.isSigned = true;

        }
        vm.prefilled = true;
        vm.date = moment(application.Date, 'DD/MM/YYYY').toDate();
        if (vm.employeeProfile.IcdOffices[0].HireDate != null) {
            vm.taxForm.hireDate = moment(vm.employeeProfile.IcdOffices[0].HireDate, 'MM/DD/YYYY')
        }
    }


    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '34', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }
    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitial: vm.employeeFirstNameMiddleInitial,
            EmployeeLastName: vm.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            ApartmentNumber: vm.aptNumber,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatus: vm.employeeStatus,
            ResidentNYC: vm.residentNYC,
            ResidentYonkers: vm.residentYonkers,
            TotalAllowances: vm.totalAllowances,
            TotalAllowancesNYC: vm.totalAllowancesNYC,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            AdditionalNYCWithholding: vm.additionalNYCWithholding,
            AdditionalYonkersWithholding: vm.additionalYonkersWithholding,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage
        };
        if (vm.ownerView) {
            let ownerData = {
                EmployeeClaimsMoreThan14Exemption: vm.morethan14,
                EmployeeIsANewHire: vm.employeeIsANewHire,
                ServiceDate: moment(vm.hireDate, 'DD/MM/YYYY').format('MM-DD-YYYY'),
                InsuranceBenefits: vm.dependentIns,
                EmpQualifyDate: moment(vm.qualificationDate, 'DD/MM/YYYY').format('MM-DD-YYYY'),
                Employername: vm.employerName,
                EmployerfederalEIN: vm.employerFederalEIN
            }
            formData = { ...formData, ...ownerData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData
            , 34)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "NY W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '2');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        showSignaturePopup: () => {
                            return vm.showSignaturePopup;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true; //employer version
                    return onSubmit();
                }
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitial: vm.employeeFirstNameMiddleInitial,
            ApartmentNumber: vm.aptNumber,
            EmployeeLastName: vm.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatus: vm.employeeStatus,
            ResidentNYC: vm.residentNYC,
            ResidentYonkers: vm.residentYonkers,
            TotalAllowances: vm.totalAllowances ? vm.totalAllowances : 0,
            TotalAllowancesNYC: vm.totalAllowancesNYC ? vm.totalAllowancesNYC : 0,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            AdditionalNYCWithholding: vm.additionalNYCWithholding,
            AdditionalYonkersWithholding: vm.additionalYonkersWithholding,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            //Signature: vm.signimage,
        };
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData
            , 34)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    //event to track if user changed any form data
    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        utilityService.showLoading();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
                return;
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            let formData = {
                RequestTypeId: '2',
                IsI9EmployeeMode: !vm.ownerView,
                EmployeeFirstNameMiddleInitial: vm.employeeFirstNameMiddleInitial,
                EmployeeLastName: vm.employeeLastName,
                EmployeeSocialSecurityNumber: vm.employeeSsn,
                EmployeeStreetaddress1Streetaddress2: vm.address,
                EmployeeCity: vm.city,
                EmployeeState: vm.stateProvince.Abbr,
                EmployeeZip: vm.zipCode,
                FilingStatus: vm.employeeStatus,
                ResidentNYC: vm.residentNYC,
                ResidentYonkers: vm.residentYonkers,
                TotalAllowances: vm.totalAllowances,
                TotalAllowancesNYC: vm.totalAllowancesNYC,
                AdditionalStateWithholding: vm.additionalStateWithholding,
                AdditionalNYCWithholding: vm.additionalNYCWithholding,
                AdditionalYonkersWithholding: vm.additionalYonkersWithholding,
                Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
                Signature: vm.signimage,
            };
            if (vm.ownerView) {
                let ownerData = {
                    EmployeeClaimsMoreThan14Exemption: vm.morethan14,
                    EmployeeIsANewHire: vm.employeeIsANewHire,
                    ServiceDate: moment(vm.hireDate, 'DD/MM/YYYY').format('MM-DD-YYYY'),
                    InsuranceBenefits: vm.dependentIns,
                    EmpQualifyDate: moment(vm.qualificationDate, 'DD/MM/YYYY').format('MM-DD-YYYY'),
                    Employername: vm.employerName,
                    EmployerfederalEIN: vm.employerFederalEIN
                }
                formData = { ...formData, ...ownerData }
            }
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 34);
            updatePromises.push(submitApplicationPromise);
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            EmployeeFirstNameMiddleInitial: vm.employeeFirstNameMiddleInitial,
            EmployeeLastName: vm.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetaddress1Streetaddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatus: vm.employeeStatus,
            ResidentNYC: vm.residentNYC,
            ResidentYonkers: vm.residentYonkers,
            TotalAllowances: vm.totalAllowances,
            TotalAllowancesNYC: vm.totalAllowancesNYC,
            AdditionalStateWithholding: vm.additionalStateWithholding,
            AdditionalNYCWithholding: vm.additionalNYCWithholding,
            AdditionalYonkersWithholding: vm.additionalYonkersWithholding,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage,
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, 34).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const NYW4Modal = {
    component: "apexNYW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}


